import React from "react";
import { CheckCircleIcon, CheckIcon } from "@heroicons/react/24/solid";
import { XCircleIcon } from "@heroicons/react/24/outline";

export const PasswordStrengthIndicator = ({ password }) => {
  const hasMinLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const requirements = [
    { text: "At least 8 characters long", met: hasMinLength },
    {
      text: "Contains 1 uppercase and 1 lowercase letter",
      met: hasUppercase && hasLowercase,
    },
    { text: "Contain symbols", met: hasSymbol },
  ];

  return (
    <div className="mt-0 text-xs md:text-sm text-[#212121] p-3 border border-[#DDE1E6] rounded-xl">
      <p className="font-medium m-0 text-xs md:text-sm">Your Password must contain:</p>
      <ul className="mt-2">
        {requirements.map((req, index) => (
          <li
            key={index}
            className={`flex items-center text-xs md:text-sm ${
              req.met ? "text-green-600" : "text-[#212121]"
            }`}
          >
            {req.met ? (
              <CheckIcon className="w-4 h-4 mr-2" />
            ) : (
              <CheckIcon className="w-4 h-4 mr-2" />
            )}
            {req.text}
          </li>
        ))}
      </ul>
    </div>
  );
};
